function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

import store from "../store";

let PackageFeatureRequired = function(requiredFeatureName) {
    return {
        async beforeRouteEnter(to, from, next) {
            if (from.name === null) {
                while (!store.state.user_data.navigator_data.hasOwnProperty('package')) {
                    await sleep(50)
                }
                while (!store.state.user_data.navigator_data.package.hasOwnProperty('features')) {
                    await sleep(50)
                }
            }
            if (!store.state.user_data.navigator_data.package.features[requiredFeatureName]) {
                store.dispatch('upgradeNavigatorPopup')
            } else {
                next()
            }
        }
    }
};

export default PackageFeatureRequired;
